import React, { useState } from "react";
import axios from "axios";
import "./DeleteImagesVariants.css";

const DeleteImagesVariants = () => {
  const [folderId, setFolderId] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const [deleting, setDeleting] = useState(false);

  const API_URL = "https://api.malidag.com";

  const handleDelete = async () => {
    if (!folderId.trim()) {
      setMessage("Please provide a folder ID.");
      setStatus("error");
      return;
    }

    try {
      setDeleting(true);
      setMessage("Deleting images-variants folder...");
      setStatus("info");

      const response = await axios.delete(`${API_URL}/delete-variants/${folderId.trim()}`);

      setMessage(response.data.message || "Images-variants folder deleted successfully.");
      setStatus("success");
      setFolderId("");
    } catch (error) {
      console.error("Delete error:", error);
      setMessage("Failed to delete images-variants.");
      setStatus("error");
    } finally {
      setDeleting(false);
    }
  };

  return (
    <div className="delete-variants">
      <div className="delete-variants__header">
        <h3 className="delete-variants__title">Delete Images-Variants Folder</h3>
        <p className="delete-variants__subtitle">
          Remove the <strong>images-variants</strong> folder for a specific folder ID.
        </p>
      </div>

      <div className="delete-variants__form">
        <div className="delete-variants__field">
          <label htmlFor="deleteFolderId" className="delete-variants__label">
            Folder ID
          </label>
          <input
            id="deleteFolderId"
            type="text"
            placeholder="Enter folder ID"
            value={folderId}
            onChange={(e) => setFolderId(e.target.value)}
            className="delete-variants__input"
          />
        </div>

        <button
          onClick={handleDelete}
          disabled={deleting}
          className="delete-variants__button"
        >
          {deleting ? "Deleting..." : "Delete Variants"}
        </button>

        {message && (
          <div className={`delete-variants__message delete-variants__message--${status}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default DeleteImagesVariants;